export default {
  title: "Budget",
  description: "Manage your wedding budget",
  totalBudget: "Total Budget",
  totalSpent: "Total Spent",
  remaining: "Remaining",
  toPay: "To pay",
  exceeded: "Exceeded",
  noCategories: "No categories configured",
  percentage: "Percentage",
  category: "Category",
  addExpense: "Add Expense",
  editExpense: "Edit Expense",
  deleteExpense: "Delete Expense",
  expenseTitle: "Expense Title",
  amount: "Amount",
  date: "Date",
  vendor: "Vendor",
  notes: "Notes",
  paid: "Paid",
  pending: "Pending",
  noExpenses: {
    title: "No expenses found",
    description: "Start by adding your first expense"
  },
  monthlyExpenses: "Monthly Spending",
  sharing: {
    recipientEmail: "Recipient Email",
    emailPlaceholder: "example@email.com",
    recipientName: "Recipient Name",
    namePlaceholder: "Name",
    message: "Message",
    messagePlaceholder: "Your message...",
    send: "Send",
    cancel: "Cancel",
    title: "Share budget"
  },
  upcomingExpenses: "Upcoming Expenses",
  recentExpenses: "Recent Expenses",
  budgetSummary: "Budget Summary",
  totalAllocated: "Total Allocated",
  totalUnallocated: "Total Unallocated",
  allocationPercentage: "Allocation Percentage",
  spendingTrend: "Spending Trend",
  averageExpense: "Average Expense",
  largestExpense: "Largest Expense",
  smallestExpense: "Smallest Expense",
  expenseCount: "Number of Expenses",
  budgetUtilization: "Budget Utilization",
  projectedTotal: "Projected Total",
  savingsGoal: "Savings Goal",
  emergencyFund: "Emergency Fund",
  contingencyPercentage: "Contingency Percentage",
  recommendedContingency: "Recommended Contingency",
  import: "Import",
  exportToCsv: "Export to CSV",
  exportToPdf: "Export to PDF",
  importFromCsv: "Import from CSV",
  downloadTemplate: "Download Template",
  budgetTemplate: "Budget Template",
  customCategory: "Custom Category",
  addCategory: "Add Category",
  categoryName: "Category Name",
  categoryBudget: "Category Budget",
  categoryAdded: "Category added successfully",
  categoryUpdated: "Category updated successfully",
  categoryDeleted: "Category deleted successfully",
  duplicateCategory: "Category already exists",
  search: "Search expenses",
  filter: "Filter",
  filterByCategory: "Filter by Category",
  filterByStatus: "Filter by Status",
  filterByDate: "Filter by Date",
  sortBy: "Sort by",
  sortByDate: "Sort by Date",
  sortByAmount: "Sort by Amount",
  sortByCategory: "Sort by Category",
  ascending: "Ascending",
  descending: "Descending",
  clearFilters: "Clear Filters",
  noFilterResults: "No expenses match your filters",
  showAll: "Show All",
  showPaid: "Show Paid",
  showPending: "Show Pending",
  thisMonth: "This Month",
  lastMonth: "Last Month",
  thisYear: "This Year",
  customRange: "Custom Range",
  from: "From",
  to: "To",
  apply: "Apply",
  reset: "Reset",
  expenseCreated: "Expense successfully created",
  totalExpenses: "{{count}} expenses",
  estimateBudget: "Estimate Budget",
  estimateBudgetShort: "Estimate",
  newExpense: "New Expense",
  add: "Add",
  overview: "Overview",
  distribution: "Distribution",
  expensesList: "List of Expenses",
  exportPdf: "Export PDF",
  budgetUsed: "Budget Used",
  loading: "Loading...",
  total: "Total",
  confirmDeleteExpense: "Are you sure you want to delete this expense?",
  categories: {
    venue: "Venue",
    catering: "Catering",
    flowers: "Flowers",
    photography: "Photography",
    music: "Music",
    attire: "Attire",
    rings: "Rings",
    transportation: "Transportation",
    decoration: "Decoration",
    invitations: "Invitations",
    gifts: "Gifts",
    honeymoon: "Honeymoon",
    miscellaneous: "Miscellaneous",
    beauty: "Beauty",
    other: "Other",
    videography: "Videography",
    accommodation: "Accommodation",
    stationery: "Stationery",
    general: "General",
    "Lieu et Réception": "Venue and Reception",
    "Animation et Photo": "Entertainment and Photo",
    "Tenues et Accessoires": "Attire and Accessories",
    title: "Categories"
  },
  form: {
    title: "Title",
    amount: "Amount",
    category: "Category",
    date: "Date",
    vendor: "Vendor",
    notes: "Notes",
    paid: "Paid",
    errors: {
      titleRequired: "Title is required",
      amountRequired: "Amount is required",
      categoryRequired: "Category is required",
      amountPositive: "Amount must be positive"
    },
    description: "Description",
    dueDate: "Due date",
    status: "Status",
    submit: "Save",
    cancel: "Cancel",
    name: "Last name"
  },
  filters: {
    all: "All",
    category: "Category",
    status: "Status",
    vendor: "Vendor",
    categoryPlaceholder: "Select category",
    vendorPlaceholder: "Select vendor",
    budgetsearch: "Search expenses",
    group: "Category",
    groupPlaceholder: "Select category...",
    tableAssigned: "Table assigned",
    allCategories: "All categories",
    allStatuses: "All statuses",
    startDate: "Start date",
    endDate: "End date",
    minAmount: "Min amount (€)",
    maxAmount: "Max amount (€)",
    resetFilters: "Reset filters",
    search: "Search an expense",
    clear: "Clear filters",
    apply: "Apply",
    previous: "Previous",
    next: "Next"
  },
  status: {
    paid: "Paid",
    unpaid: "Unpaid",
    pending: "Pending",
    cancelled: "Cancelled"
  },
  table: {
    title: "Title",
    amount: "Amount",
    category: "Category",
    date: "Date",
    status: "Status",
    description: "Description",
    actions: "Actions"
  },
  estimator: {
    title: "Budget Estimator",
    guestCount: "Guest Count",
    region: "Region",
    services: "Services",
    lieu: "Venue",
    traiteur: "Catering",
    photographie: "Photography",
    fleurs: "Flowers",
    musique: "Music",
    tenues: "Attire",
    calculate: "Calculate",
    estimatedBudget: "Estimated Budget",
    validateBudget: "Validate Budget",
    adjustAmount: "Adjust Amount",
    modifyCriteria: "Modify Criteria",
    next: "Next",
    previous: "Previous",
    ileDeFrance: "Île-de-France (Paris Region)",
    paca: "PACA (French Riviera)",
    london: "London",
    otherUK: "Other UK",
    madrid: "Madrid",
    barcelona: "Barcelona",
    berlin: "Berlin",
    munich: "Munich",
    otherRegion: "Other region",
    style: "What wedding style do you want?"
  },
  noExpensesFiltered: {
    title: "No expenses match your filters",
    description: "Try adjusting your search criteria"
  },
  overrun: {
    title: "Budget exceeded",
    description: "You've exceeded your planned budget"
  },
  success: {
    budgetUpdated: "Budget updated successfully"
  },
  errors: {
    addExpense: "Error adding expense",
    deleteExpense: "Error deleting expense",
    updateExpense: "Error updating expense",
    loadExpenses: "Error loading expenses",
    loadCategories: "Error loading categories",
    loadWedding: "Error loading wedding data",
    loadTemplate: "Error loading template",
    updateBudget: "Error updating budget",
    noTemplateAvailable: "No template available",
    noWeddingFound: "No wedding found",
    loadData: "Error loading data",
    noUser: "No user logged in",
    missingWeddingId: "Missing wedding ID"
  },
  export: {
    title: "Wedding Budget Report",
    date: "Date",
    totalBudget: "Total Budget",
    totalSpent: "Total Spent",
    remaining: "Remaining",
    categoryStats: {
      title: "Expenses by Category",
      headers: {
        category: "Category",
        amount: "Amount",
        percentage: "Percentage"
      }
    },
    table: {
      headers: {
        title: "Title",
        category: "Category",
        subcategory: "Subcategory",
        amount: "Amount",
        date: "Date",
        vendor: "Vendor",
        paid: "Paid",
        notes: "Notes"
      },
      values: {
        yes: "Yes",
        no: "No",
        notSpecified: "Not specified"
      }
    }
  },
  pageExample: {
    title: "Budget Management",
    subtitle: "Plan and track your wedding expenses",
    connectedAs: "Connected as",
    noAccess: "No access",
    overviewDescription: "General overview of your expenses and remaining budget",
    detailedExpenses: "Detailed Expenses",
    detailedExpensesDescription: "Complete list of all your expenses",
    share: "Share",
    venues: {
      receptionVenue: "Reception Venue",
      chateauVersailles: "Château de Versailles"
    },
    access: {
      readOnlyAccess: "Read-only access - Cannot modify",
      advancedConfig: "Advanced Configuration",
      advancedConfigDescription: "Budget settings and configuration",
      adminOnly: "Admin only",
      adminZone: "Administration Zone",
      adminZoneDescription: "This section contains sensitive settings that are only accessible to administrators.",
      exportData: "Export Data",
      resetBudget: "Reset Budget",
      permissionsInfo: "Your Permissions Information",
      read: "Read",
      write: "Write",
      delete: "Delete",
      share: "Share"
    },
    description: "This is an example budget page with dummy data",
    accessLevel: "Access level",
    permissions: "Permissions",
    venue: {
      title: "Venue",
      name: "Château des Roses",
      capacity: "Capacity: 150 people",
      location: "Provence, France",
      contact: "Contact: +33 1 23 45 67 89"
    },
    admin: {
      title: "Administration",
      exportData: "Export data",
      importData: "Import data",
      backupData: "Backup data",
      resetData: "Reset data"
    },
    status: {
      connected: "Connected",
      synchronized: "Synchronized",
      lastUpdate: "Last update: {{date}}"
    }
  },
  initialBudget: "Initial Budget",
  used: "used",
  paymentStatus: "Payment Status",
  categoryProgress: "Category Progress",
  addExpenseLabel: "Add Expense",
  addFirstExpense: "Add your first expense",
  budgetOverview: "Budget overview",
  expenseDetails: "Expense details",
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  view: "View",
  confirmDelete: "Are you sure you want to delete this expense?",
  expenseAdded: "Expense added successfully",
  expenseUpdated: "Expense updated successfully",
  expenseDeleted: "Expense deleted successfully",
  budgetExceeded: "Budget exceeded",
  budgetWarning: "Budget warning",
  budgetOnTrack: "Budget on track",
  setBudget: "Set budget",
  editBudget: "Edit budget",
  budgetAmount: "Budget amount",
  budgetSet: "Budget set successfully",
  budgetUpdated: "Budget updated successfully",
  currency: "Currency",
  estimatedCost: "Estimated cost",
  actualCost: "Actual cost",
  difference: "Difference",
  overBudget: "Over budget",
  underBudget: "Under budget",
  onBudget: "On budget",
  budgetAnalysis: "Budget analysis",
  categoryBreakdown: "Category breakdown",
  monthlySpending: "Monthly expenses",
  noExpensesText: "No expenses",
  importExpenses: "Import expenses",
  exportExpenses: "Export expenses",
  budgetDetails: "Budget details",
  budgetHistory: "Budget history",
  budgetAnalytics: "Budget analytics",
  budgetSettings: "Budget settings",
  spent: "Spent",
  expenses: {
    title: "Expenses",
    add: "Add an expense",
    edit: "Edit expense",
    name: "Last name",
    amount: "Amount",
    category: "Category",
    date: "Date",
    paid: "Paid",
    unpaid: "Unpaid",
    notes: "Notes",
    vendor: "Vendor",
    noExpenses: "No expenses",
    total: "Total",
    filter: "Filter",
    search: "Search",
    delete: "Delete",
    confirm: "Confirm"
  },
  modal: {
    title: "Expense",
    edit: "Edit expense",
    delete: "Delete expense",
    confirmDelete: "Are you sure you want to delete this expense?"
  },
  summary: {
    total: "Total",
    spent: "Spent",
    remaining: "Remaining",
    overBudget: "Overspend",
    currency: "€"
  },
  analytics: {
    title: "Budget analytics",
    insights: {
      title: "Insights and trends",
      topCategory: {
        title: "Top category",
        description: "{{category}} represents {{percentage}}% of your expenses with {{amount}}"
      },
      overBudget: {
        title: "Budget exceeded",
        description: "You exceeded your budget by {{percentage}}% ({{amount}})"
      },
      nearBudget: {
        title: "Budget nearly reached",
        description: "You have used {{percentage}}% of your budget. You have {{remaining}} left"
      },
      increasingTrend: {
        title: "Spending increasing",
        description: "Your expenses increased by {{amount}} this month ({{month}})"
      },
      decreasingTrend: {
        title: "Spending decreasing",
        description: "Your expenses decreased by {{amount}} this month ({{month}})"
      }
    },
    charts: {
      categoryDistribution: "Category breakdown",
      monthlyTrend: "Monthly trend",
      monthlySpending: "Monthly expenses",
      cumulativeSpending: "Cumulative spending",
      averagePerCategory: "Average by category",
      averageSpending: "Average spending"
    },
    details: {
      title: "Detailed statistics",
      transactions: "transactions",
      average: "Average"
    },
    overview: "Overview",
    byCategory: "By category",
    byMonth: "By month",
    trends: "Trends"
  },
  messages: {
    createSuccess: "Expense added successfully",
    updateSuccess: "Expense updated successfully",
    deleteSuccess: "Expense deleted successfully",
    deleteConfirm: "Are you sure you want to delete this expense?",
    error: "An error occurred",
    budgetCreated: "Budget created successfully",
    budgetUpdated: "Budget updated successfully",
    budgetDeleted: "Budget deleted successfully",
    expenseAdded: "Expense added successfully",
    expenseUpdated: "Expense updated successfully",
    expenseDeleted: "Expense deleted successfully",
    categoryAdded: "Category added successfully",
    categoryUpdated: "Category updated successfully",
    categoryDeleted: "Category deleted successfully"
  }
};
